import { Component, error, _decorator } from 'cc';
import TableGame from '../System/TableGame';

const { ccclass } = _decorator;

@ccclass('GameSharedAsset')
export default class GameSharedAsset extends Component {
    public onLoad() {
        if (TableGame.sharedAsset) {
            this.destroy();
            error('No duplicate GameSharedAsset');
            return;
        }
        TableGame.sharedAsset = this;
    }
}
